import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Overlay } from 'vant';
import { Toast } from 'vant';
import { Loading } from 'vant';
import { Image as VanImage } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/font/font.css'
import MiniAudio from 'vue-audio-better'
// import 'toca-bridge';
Vue.use(MiniAudio)
Vue.use(ElementUI);
Vue.use(VanImage);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Overlay);

Vue.config.productionTip = false
import './utils/rem'

router.beforeEach((to, from, next) => {
  if (to.meta) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
